import React, { useEffect } from 'react';
import { ModalComponent } from 'new/routes/RouterManager';
import { Typography } from '@mui/material';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { useFilePath } from 'new/hooks/adapters/useFilePath';
import { useResource } from 'new/components/monitor/ResourceTriage/useResource';
import { useDispatch } from 'react-redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { FILE_REINGESTION_REQUEST } from 'js/constants/actionTypes';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';
import { useModals } from 'new/hooks/useModals';
import { reingestFile } from 'js/actions';

interface ModalReingestProps {
  fileName: string;
  displayFileName: string;
  fileId: string;
  resourceId: string;
  resourceType: string;
  filters: any;
}

export const ModalReingest: ModalComponent = (props: ModalReingestProps & ModalOutProps) => {
  const {
    setTitle,
    setModalActions,
    fileName,
    resourceType,
    resourceId,
    setLoading,
    fileId,
    filters,
  } = props;

  const finalDisplayFileName = props?.displayFileName || fileName || '';
  const title = `Please confirm that you would like to trigger reingestion of file ${finalDisplayFileName}`;

  const { resource } = useResource(resourceType, resourceId);
  const loading = useIsLoading(FILE_REINGESTION_REQUEST);
  const filePath = useFilePath(fileName, resource?.source_type, resource?.source_config);
  const { closeModal } = useModals();
  const dispatch = useDispatch();

  const onClickReingest = () => {
    const _id = fileId;
    const _payload = [{ file: fileName, path: filePath }];
    const _filters = {
      page: 1,
      size: 50,
      orderby: 'lastIngested&sortorder=desc',
      status: '',
      ...filters,
    };

    dispatch(reingestFile(_id, _payload, _filters));
  };

  useDidUpdateEffect(() => {
    setLoading(loading);
    if (!loading) {
      closeModal(ModalReingest.modalConfig.name);
    }
  }, [loading]);

  useEffect(() => {
    setTitle(title);
    setModalActions({
      ok: {
        text: 'Reingest',
        onClick: onClickReingest,
      },
    });
  }, []);

  return (
    <div>
      <Typography>
        Triggering reingestion of this file will result in the whole file being read again at the
        next poll cycle of this source, resulting in duplicate ingestion of records that had already
        been read.
      </Typography>
    </div>
  );
};

ModalReingest.modalConfig = {
  name: 'ModalReingest',
  maxWidth: 'lg',
};
